<template>
    <zone
        align="left"
        class="faq"
        contrast="light"
        :auto-height="$breakpoint.isS"
        :background-image="images.background"
        :data-label="dico.dataLabel"
        :id="dico.id"
        v-if="isDisplayed"
    >
        <heading :level="2" v-html="dico.title"/>
        <faq-accordion :items="dico.list"/>
    </zone>
</template>

<script>
import Heading from 'gvue/src/core/Heading'
import Zone from 'gvue/src/core/Zone'

import FaqAccordion from '@/components/faq/FaqAccordion'

import { getBackground } from '@/helpers/visual'

export default {
    name: 'SectionFaq',
    components: {
        FaqAccordion,
        Heading,
        Zone
    },
    data () {
        return {
            dico: this.$json.faq
        }
    },
    computed: {
        images () {
            return { background: getBackground(this.dico.background) }
        },
        isDisplayed () {
            return this.dico.display
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.faq
    background-color: #F9F9F9

+mobile
    .g_section
        display: flex
        flex-direction: column-reverse

    .g
        .g_h2
            text-align: center

    /deep/
        .g_bg
            padding-top: 100%
            position: static

+desktop
    /deep/
        .g_bg
            background-position: center top
            background-size: 100% auto

</style>
